// extracted by mini-css-extract-plugin
export default {"leftSideWrapper":"gJq88","center":"_1PiAR","backBtn":"_3gBW1"};